import { useState } from 'react';

export function OpenItemAnswerCard({ openItemId, expectedVersion, onAnswer }: { openItemId: string; expectedVersion: number; onAnswer: (input: { openItemId: string; expectedVersion: number; text: string }) => void }) {
  const [text, setText] = useState('');
  return (
    <form onSubmit={(event) => { event.preventDefault(); onAnswer({ openItemId, expectedVersion, text }); }} className="flex flex-col gap-2">
      <label htmlFor={`answer-${openItemId}`} className="text-sm font-semibold">Answer</label>
      <textarea id={`answer-${openItemId}`} value={text} onChange={(event) => setText(event.target.value)} rows={4} className="rounded-md border border-input px-3 py-2" />
      <button type="submit" className="min-h-11 rounded-md bg-foreground px-4 text-sm font-semibold text-background">Save answer</button>
    </form>
  );
}

